import { CompanyService } from "@/views/cooperation/company/company.service";
import { message } from "ant-design-vue";
import _ from "lodash";
import { HttpService } from "@/core";
import { ExportReq, ExportResp, BaseClass } from "@/core/interface";
import { ProfileService as ContractService } from "@/views/contract";
import {
  InvoicePageReq,
  InvoicePageResp,
  InvoiceDetailResp,
  InvoiceReq,
  ContractAmountReq,
  ContractAmountReqResp,
} from "./invoice.interface";

export class ContractBackfillResult extends BaseClass {
  projectId: string | undefined = undefined;
  invoiceType: string | undefined = undefined;
  taxRate: string | undefined | null = undefined;
  amount:number | undefined = undefined
}

export class CompanyBackfillResult {
  receivedInvoiceCompanyId: string = "";
  title: string = ""; // 开票抬头
  taxNo: string = ""; // 税号
  openingBank: string = ""; // 开户银行
  openingAccount: string = ""; // 开户银行账号
  telephone: string = ""; // 开票电话
  address: string = ""; // 开票地址
  provinceId: number = 0;
  cityId: number = 0;
  districtId: number = 0;
}

export class InvoiceService {
  static usePageListApi() {
    const api = (params: InvoicePageReq) =>
      HttpService.axios({
        method: "GET",
        url: `/common_api/page/add/project/list/${params.bizType}`,
        params,
      });
    return HttpService.usePagination<InvoicePageResp>(api);
  }

  static usePageApi() {
    const api = (params: InvoicePageReq) =>
      HttpService.axios({
        method: "GET",
        url: "/invoice_application/pageList",
        params,
      });
    return HttpService.usePagination<InvoicePageResp>(api);
  }

  static useDetailApi() {
    const api = (id: string) =>
      HttpService.axios({
        method: "GET",
        url: `/invoice_application/${id}`,
      });
    return HttpService.useRequest<InvoiceDetailResp>(api);
  }

  static useCreateApi() {
    const api = (data: InvoiceReq) =>
      HttpService.axios({
        method: "POST",
        url: "/invoice_application",
        data: InvoiceService.profileReqToAjaxData(data),
      });
    return HttpService.useRequest<{ id: string }>(api);
  }

  static useEditApi() {
    const api = (id: string, data: InvoiceReq) =>
      HttpService.axios({
        method: "PUT",
        url: `/invoice_application/${id}`,
        data: InvoiceService.profileReqToAjaxData(data),
      });
    return HttpService.useRequest<{ id: string }>(api);
  }

  static useDeleteApi() {
    const api = (id: string) =>
      HttpService.axios({
        method: "DELETE",
        url: `/invoice_application/${id}`,
      });
    return HttpService.useRequest<void>(api);
  }

  static useExportApi() {
    const api = (ids: ExportReq) =>
      HttpService.axios({
        method: "GET",
        url: "/invoice_application/export",
        params: { ids },
      });
    return HttpService.useRequest<ExportResp>(api);
  }

  static useContractAmountApi() {
    const api = (params: ContractAmountReq) =>
      HttpService.axios({
        method: "GET",
        url: "/invoice_application/contractAmount",
        params,
      });
    return HttpService.usePagination<ContractAmountReqResp>(api);
  }

  static profileReqToAjaxData(req: InvoiceReq) {
    req = _.cloneDeep(req);
    return req;
  }

  static detailRespToInvoiceReq(resp: InvoiceDetailResp): InvoiceReq {
    const profileReq = new InvoiceReq();
    profileReq.pick(resp);
    return profileReq;
  }

  static async backfillByInvoiceId(invoiceId): Promise<InvoiceReq> {
    let result = new InvoiceReq();
    if (!invoiceId) {
      return result;
    }
    const { run } = InvoiceService.useDetailApi();
    const res = await run(invoiceId);
    if (res.respCode === "0000" && res.data) {
      result = InvoiceService.detailRespToInvoiceReq(res.data);
    }
    return result;
  }

  static async backfillByContractId(contractId): Promise<ContractBackfillResult> {
    const result = new ContractBackfillResult();
    if (!contractId) {
      return result;
    }
    const { run } = ContractService.useDetailApi();
    const res = await run(contractId);
    if (res.respCode === "0000" && res.data) {
      result.merge(res.data);
    }
    return result;
  }

  static async backfillByCompanyId(companyId,cb=(e)=>{}) {
    const result = new CompanyBackfillResult();
    if (!companyId) {
      return result;
    }
    const { run } = CompanyService.useDetailApi();
    const res = await run(companyId);
    if (res.respCode === "0000" && res.data) {
      const { invoices, telephone, provinceId, cityId, districtId, address } = res.data;
      if (invoices.length > 0) {
        const firstInvoice = invoices[0];
        const { title, taxNo, openingBank, openingAccount } = firstInvoice;
        if (title.length > 0 && openingAccount.length > 0 && openingBank.length > 0) {
          result.receivedInvoiceCompanyId = companyId;
          result.title = title;
          result.taxNo = taxNo;
          result.openingBank = openingBank;
          result.openingAccount = openingAccount;
          result.telephone = telephone;
          result.provinceId = provinceId;
          result.cityId = cityId;
          result.districtId = districtId;
          result.address = address;
        } else {
          message.error("请先完善往来单位");
          cb("请先完善往来单位");
        }
      } else {
        message.error("请先完善往来单位");
        cb("请先完善往来单位");
      }
    }
    return result;
  }
  static cooperationCompanyApi() {
    const api = (id: string) =>
      HttpService.axios({
        method: "GET",
        url: `/cooperation_company/${id}`,
      });
    return HttpService.useRequest<any>(api);
  }
}
